var exports = {
  "kL": "container__M8nLeD",
  "Y3": "anchor__T-V5ON",
  "xv": "truncate__InwcX4",
  "bt": "trailingBadges__yLRzDg",
};

module.exports = exports;
